"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _chart = require("chart.js");
var _reactChartjs = require("react-chartjs-2");
var _useCanSSR = _interopRequireDefault(require("../../hooks/useCanSSR"));
var _excluded = ["context", "chartData", "hasTitle", "padding", "hasLegend", "isStacked", "labelAxis"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// function isCanvasSupported() {
//     var elem = document.createElement('canvas');
//     return !!(elem.getContext && elem.getContext('2d'));
// }
var colors = {
  new: ['rgba(138, 177, 47, 0.7)', 'rgba(22, 151, 197, 0.7)', 'rgba(132, 54, 210, 0.7)', 'rgba(245, 172, 35, 0.7)', 'rgba(240, 80, 80, 0.7)'],
  used: ['rgba(138, 177, 47, 0.2)', 'rgba(22, 151, 197, 0.2)', 'rgba(132, 54, 210, 0.2)', 'rgba(245, 172, 35, 0.2)', 'rgba(240, 80, 80, 0.2)'],
  default: ['rgba(138, 177, 47, 0.7)', 'rgba(22, 151, 197, 0.7)', 'rgba(132, 54, 210, 0.7)', 'rgba(245, 172, 35, 0.7)', 'rgba(240, 80, 80, 0.7)']
};

// if (typeof window !== 'undefined' && isCanvasSupported()) {
//     /**
//      * Define somme global options
//      */
//     Chart.defaults.elements.bar.borderWidth = 1;
//     Chart.defaults.datasets.bar.barPercentage = 1;
//     Chart.defaults.datasets.bar.barThickness = 'flex';
//     Chart.defaults.datasets.bar.categoryPercentage = 1;
//     Chart.defaults.color = '#000000';
//     Chart.defaults.font.size = 10;
//     Chart.defaults.font.family = "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif";
// }

var ChartBar = function ChartBar(_ref) {
  var context = _ref.context,
    chartData = _ref.chartData,
    hasTitle = _ref.hasTitle,
    padding = _ref.padding,
    hasLegend = _ref.hasLegend,
    isStacked = _ref.isStacked,
    labelAxis = _ref.labelAxis,
    attributes = _objectWithoutPropertiesLoose(_ref, _excluded);
  var isSsr = (0, _useCanSSR.default)();
  var refChart = (0, _react.useRef)(null);
  var refLegends = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(null),
    dataBar = _useState[0],
    setDataBar = _useState[1];
  var _useState2 = (0, _react.useState)(null),
    legends = _useState2[0],
    setLegends = _useState2[1];
  var cData = chartData[0],
    cLegend = chartData[1];
  (0, _react.useEffect)(function () {
    if (cData && cLegend && Object.keys(cData).length > 0 && Object.keys(cLegend).length > 0) {
      var _formatData = formatData(cData, cLegend),
        fData = _formatData[0],
        fLegend = _formatData[1];
      setDataBar(fData);
      setLegends(fLegend);
    }
  }, [cData, cLegend]);
  (0, _react.useEffect)(function () {
    if (refChart.current && refChart.current.chartInstance && legends && Object.keys(legends).length > 0) {
      refChart.current.chartInstance.generateLegend();
    }
  }, [legends]);
  (0, _react.useEffect)(function () {
    if (refChart.current && refChart.current.chartInstance && dataBar && Object.keys(dataBar).length > 0) {
      refChart.current.chartInstance.update();
    }
  }, [dataBar]);
  if (isSsr) return null;
  _chart.Chart.register(_chart.CategoryScale, _chart.LinearScale, _chart.BarElement, _chart.Legend, _chart.Title, _chart.Tooltip);
  /**
   * Define somme global options
   */
  _chart.Chart.defaults.elements.bar.borderWidth = 1;
  _chart.Chart.defaults.datasets.bar.barPercentage = 1;
  _chart.Chart.defaults.datasets.bar.barThickness = 'flex';
  _chart.Chart.defaults.datasets.bar.categoryPercentage = 1;
  _chart.Chart.defaults.color = '#000000';
  _chart.Chart.defaults.font.size = 10;
  _chart.Chart.defaults.font.family = "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif";
  var htmlLegendMarkup = function htmlLegendMarkup(chart, items, id) {
    var ul = '';
    if (legends && cData) {
      cData.forEach(function (elm, indexData) {
        if (cData.length >= 2) {
          ul += "<div class=\"uk-chart__labels\"><strong class=\"margin-right-1\">" + legends.axis[indexData].label + ":</strong><ul>";
          legends.legend.forEach(function (label, indexLabel) {
            ul += "<li>\n                                <span style=\"background-color: " + (legends.axis[indexData].key === 'sales_new' ? colors.new[indexLabel] : colors.used[indexLabel]) + "\"></span>\n                                " + label + "\n                            </li>";
          });
          ul += '</ul></div>';
        } else {
          ul += "<div class=\"uk-chart__labels\"><span>" + legends.axis[indexData].label + ":</span><ul>";
          legends.legend.forEach(function (label, indexLabel) {
            ul += "<li>\n                                <span style=\"background-color: " + colors.default[indexLabel] + "\"></span>\n                                " + label + "\n                            </li>";
          });
          ul += '</ul></div>';
        }
      });
    }
    refLegends.current.innerHTML = ul;
  };

  // Create HTML markup for legends
  var legendMarkup = {
    id: 'htmlLegend',
    afterUpdate: function afterUpdate(chart, args, options) {
      // Reuse the built-in legendItems generator
      var items = chart.options.plugins.legend.labels.generateLabels(chart);
      htmlLegendMarkup(chart, items, options.containerID);
    }
  };

  /**
   * Format data
   */
  function formatData(data, legend) {
    var barData = [];
    var axis = [];
    var legends = [];
    if (legend && legend.length > 0) {
      // Create an object of labels for axes
      legend.forEach(function (item) {
        axis.push({
          label: item.label,
          key: item.key
        });
      });

      // Create an array of legends
      legend[0].legend.forEach(function (item) {
        legends.push(item.label || item.key.charAt(0).toUpperCase() + item.key.slice(1));
      });
    }
    if (data && data.length > 0) {
      // Create datasets from sales_new and sales_used
      // and add an new property <stack> to group two stacked bar
      if (data.length >= 2) {
        for (var _iterator = _createForOfIteratorHelperLoose(data), _step; !(_step = _iterator()).done;) {
          var sales = _step.value;
          if (sales.sales_new) {
            sales.sales_new.forEach(function (item, index) {
              barData.push({
                data: item.data,
                label: axis[0].label + ': ' + legends[index],
                stack: 'New',
                backgroundColor: colors.new[index]
              });
            });
          }
          if (sales.sales_used) {
            sales.sales_used.forEach(function (item, index) {
              barData.push({
                data: item.data,
                label: axis[1].label + ': ' + legends[index],
                stack: 'Used',
                backgroundColor: colors.used[index]
              });
            });
          }
        }
      } else {
        var datasets = Object.values(data[0])[0];
        datasets.forEach(function (item, index) {
          barData.datasets.push(_extends({}, item, {
            backgroundColor: colors.default[index]
          }));
        });
      }
    }
    return [{
      datasets: barData
    }, {
      axis: axis,
      legend: legends
    }];
  }

  /**
   * Define options
   */
  var options = {
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: true,
        title: {
          display: labelAxis.x.display,
          text: labelAxis.x.text
        }
      },
      y: {
        stacked: true,
        suggestedMin: 0,
        suggestedMax: 4,
        maxTicksLimit: 6,
        title: {
          display: labelAxis.y.display,
          text: labelAxis.y.text
        }
      }
    },
    plugins: {
      htmlLegend: {
        containerID: 'htmlLegendId'
      },
      legend: {
        display: false,
        position: hasLegend.position,
        align: hasLegend.align,
        labels: {
          boxWidth: 8,
          usePointStyle: true,
          padding: 15
        }
      },
      title: {
        display: hasTitle,
        position: hasTitle.position,
        text: hasTitle.text,
        font: {
          size: 14
        }
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        position: 'nearest'
      }
    }
    // legendCallback: legendMarkup,
    // plugins: [legendMarkup]
  };

  if (!dataBar) return null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-chart"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-chart__container"
  }, /*#__PURE__*/_react.default.createElement(_reactChartjs.Bar, _extends({
    plugins: [legendMarkup],
    data: dataBar,
    options: options,
    ref: refChart
  }, attributes))), /*#__PURE__*/_react.default.createElement("div", {
    ref: refLegends,
    className: "uk-chart__legends",
    id: "htmlLegendId"
  })));
};
ChartBar.propTypes = {
  /**
   * Chart data
   */
  chartData: _propTypes.default.any.isRequired,
  /**
   * Stack bar chart to show how one data series is made up of a number of smaller pieces. To do so enable stacking.
   * Note. Only in stake mode you can use a property <Name: stack; Type: string> to dataset with an ID.
   * The ID of the group to which this database belongs to.
   * Warning! Props isStacked: false not working right now. It's hardcoded at value 'true'
   */
  isStacked: _propTypes.default.bool,
  /**
   * Enable/disable label for axis X/Y and define an title
   */
  labelAxis: _propTypes.default.shape({
    x: _propTypes.default.shape({
      display: _propTypes.default.bool,
      title: _propTypes.default.string
    }),
    y: _propTypes.default.shape({
      display: _propTypes.default.bool,
      title: _propTypes.default.string
    })
  }),
  /**
   * Title text to display and position of title
   */
  hasTitle: _propTypes.default.oneOfType([_propTypes.default.shape({
    position: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left']),
    text: _propTypes.default.string
  }), _propTypes.default.bool]),
  /**
   * Number of pixels to add inside of chart
   */
  padding: _propTypes.default.number,
  /**
   * Display legend, manage position and alignment
   */
  hasLegend: _propTypes.default.shape({
    position: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left']),
    align: _propTypes.default.oneOf(['start', 'center', 'end'])
  })
};
ChartBar.defaultProps = {
  isStacked: true,
  labelAxis: {
    x: {
      display: true,
      text: 'Days'
    },
    y: {
      display: true,
      text: 'Number of cars'
    }
  },
  hasTitle: false,
  padding: 0,
  hasLegend: {
    position: 'bottom',
    align: 'start'
  }
};
var _default = exports.default = ChartBar;